import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';
import { SVIPUserProps } from '@/views/user/member/service';

const NOTACTIVATED_KEY = 'React-ts-ant-notActivated';

const localNotActivated = LocalStore.getValue<SVIPUserProps>(NOTACTIVATED_KEY) || {};

export const defaults: SVIPUserProps = {
  message: [],
  icon: [],
  ...localNotActivated
};

const NOT_ACTIVATED_KEY = 'React-ts-ant-NOTACTIVATED';

export const updateNotActivateds: (notActivateds: SVIPUserProps) => IAction<SVIPUserProps> = (
  notActivateds: SVIPUserProps
) => ({
  type: NOT_ACTIVATED_KEY,
  payload: notActivateds
});

const notActivatedReducer: Reducer<SVIPUserProps, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case NOT_ACTIVATED_KEY:
      LocalStore.setValue(NOTACTIVATED_KEY, payload as SVIPUserProps);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default notActivatedReducer;
